/**
 * Spacing tokens for map entity detail cards rendered inside `MapEntityDrawer`.
 *
 * These back the default spacing of the `MapEntityDetailsLayout` primitives
 * (`Body`, `Meta`, `Actions`). Values are MUI theme-spacing units. Compose the
 * primitives rather than hand-rolling equivalent spacing; pages with bespoke,
 * full-bleed layouts (e.g. AlertDetails) may still lay out their own body
 * content directly.
 */
export const MAP_ENTITY_DETAILS_LAYOUT_SPACING = {
  bodyPaddingX: 2,
  bodyPaddingBottom: 3,
  bodyGap: 2,
  actionsSpacing: 1,
  metaGap: 0.5,
} as const;
